import * as React from 'react';
import { STAR_FILL_MAP } from '../constants/star';
import { EStarTheme } from '../types/star';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var useGradient = function useGradient(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    theme = _ref.theme,
    color = _ref.color;
  var gradientId = "gradient-newbuilding_reviews_rating-".concat(value);
  var gradient = React.useMemo(function () {
    var offset = "".concat(value * 100, "%");
    return /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: gradientId,
        y2: "0%",
        x2: "100%",
        y1: "0%",
        x1: "0%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopOpacity: "1",
          stopColor: "var(--accent-warning-primary)"
        }), /*#__PURE__*/_jsx("stop", {
          offset: offset,
          stopOpacity: "1",
          stopColor: "var(--accent-warning-primary)"
        }), /*#__PURE__*/_jsx("stop", {
          offset: offset,
          stopOpacity: "0",
          stopColor: "var(--accent-warning-primary)"
        }), /*#__PURE__*/_jsx("stop", {
          offset: offset,
          stopOpacity: "1",
          stopColor: "#ced1d7"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopOpacity: "1",
          stopColor: "#ced1d7"
        })]
      })
    });
  }, [gradientId, value]);
  var fill = React.useMemo(function () {
    return theme === EStarTheme.Fillable ? "url(#".concat(gradientId, ")") : color || STAR_FILL_MAP[theme];
  }, [gradientId, theme, color]);
  return {
    gradient: gradient,
    fill: fill
  };
};